import PackingIcon from '@material-ui/icons/GridOn'
import PackingList from './PackingList';
import PackingEdit from './PackingEdit';
import PackingCreate from './PackingCreate'
import jwt_decode from 'jwt-decode'

export default {
    list: PackingList,
    edit: PackingEdit,
    create: PackingCreate,
    icon: PackingIcon,
};
